import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import axios from "axios";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Card, Popover, TablePagination, Button } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import "../App.css";
import * as XLSX from "xlsx";
import "../components/loader.css";
import * as images from "../utils/images/images.component";
import { AgentDataDetails } from "./AgentDataDetails";
import "../App.css";

interface Column {
  id:
    | "agent"
    | "ucid"
    | "score_fatal"
    | "WrapUpDuration"
    | "StartTime"
    | "EndTime"
    | "TimeToAnswer"
    | "Duration"
    | "campaign"
    | "audio_url"
    | "disposition"
    | "skill"
    | "call_type"  
    | "call_time"  
    | "call_date"
    | "language"
    | "CallerID"  
    | "call_opening_intro"  
    | "brand_name_check"  
    | "opening_assist"  
    | "customer_name_confirm"  
    | "order_verification"  
    | "agent_probing_check"  
    | "agent_energetic_check"  
    | "agent_rate_of_speech_check"  
    | "agent_speech_clarity"  
    | "agent_filler_avoidance"  
    | "agent_jargon_avoidance"  
    | "agent_slang_avoidance"  
    | "language_switch_permission"  
    | "agent_respond_on_time"  
    | "agent_avoid_customer_repeat"  
    | "agent_interruption_avoidance"  
    | "agent_lethargy_check"  
    | "agent_calmness_patience"  
    | "agent_positive_language"  
    | "agent_acknowledge"  
    | "agent_empathy_check"  
    | "agent_polite"  
    | "agent_clear_articulation"  
    | "agent_proactive"  
    | "agent_professional"  
    | "agent_rude_avoidence"  
    | "agent_speaking_clearly"  
    | "agent_abusive_avoidence"  
    | "agent_call_disconnect_avoidence"  
    | "agent_hold_return_timing"  
    | "agent_hold_thanking"  
    | "agent_dead_air_avoidance"  
    | "agent_hold_update_refresh"  
    | "agent_retention_effort"  
    | "repeat_caller"  
    | "agent_upsell"  
    | "issue_resolved"  
    | "agent_further_assistance"  
    | "agent_thanked_customer"  
    | "agent_mentioned_brand_at_closing"  
    | "score"
    | "summary"
    | "training_needs_identification"
    | "areas_of_improvement"
    ;
  label: string;
  minWidth?: number;
  align?: "right";
}
interface DataItem {
  [key: string]: string;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 10,
    padding: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    padding: 10,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const columns: readonly Column[] = [
  { id: "audio_url", label: "Audio", minWidth: 150 },
  { id: "score", label: "Score", minWidth: 100 },
  { id: "score_fatal", label: "Fatal Score", minWidth: 100 },
  { id: "call_date", label: "Call Date", minWidth: 100 },
  { id: "StartTime", label: "Start Time", minWidth: 100 },
  { id: "EndTime", label: "End Time", minWidth: 100 },
  { id: "call_type", label: "Call Type", minWidth: 120 },
  { id: "CallerID", label: "Caller ID", minWidth: 100 },
  { id: "call_time", label: "Call Time", minWidth: 100 },
  { id: "language", label: "Language", minWidth: 100 },
  { id: "agent", label: "Agent Name", minWidth: 150 },
  { id: "ucid", label: "UCID", minWidth: 100 },
  { id: "campaign", label: "Campaign", minWidth: 120 },
  { id: "disposition", label: "Disposition", minWidth: 120 },
  { id: "call_opening_intro", label: "Opening Intro", minWidth: 120 },
  { id: "brand_name_check", label: "Brand Name Check", minWidth: 120 },
  { id: "opening_assist", label: "Opening Assist", minWidth: 120 },
  { id: "customer_name_confirm", label: "Customer Name Confirm", minWidth: 150 },
  { id: "order_verification", label: "Order Verification", minWidth: 150 },
  { id: "agent_probing_check", label: "Probing Check", minWidth: 120 },
  { id: "agent_energetic_check", label: "Energetic Check", minWidth: 100 },
  { id: "agent_rate_of_speech_check", label: "Rate of Speech Check", minWidth: 150 },
  { id: "agent_speech_clarity", label: "Speech Clarity", minWidth: 120 },
  { id: "agent_filler_avoidance", label: "Filler Avoidance", minWidth: 150 },
  { id: "agent_jargon_avoidance", label: "Jargon Avoidance", minWidth: 150 },
  { id: "agent_slang_avoidance", label: "Slang Avoidance", minWidth: 150 },
  { id: "language_switch_permission", label: "Language Switch", minWidth: 150 },
  { id: "agent_respond_on_time", label: "Respond On Time", minWidth: 120 },
  { id: "agent_avoid_customer_repeat", label: "Avoid Customer Repeat", minWidth: 150 },
  { id: "agent_interruption_avoidance", label: "Interruption Avoidance", minWidth: 150 },
  { id: "agent_lethargy_check", label: "Lethargy Check", minWidth: 100 },
  { id: "agent_calmness_patience", label: "Calmness & Patience", minWidth: 150 },
  { id: "agent_positive_language", label: "Positive Language", minWidth: 150 },
  { id: "agent_acknowledge", label: "Acknowledge", minWidth: 120 },
  { id: "agent_empathy_check", label: "Empathy Check", minWidth: 120 },
  { id: "agent_polite", label: "Polite", minWidth: 120 },
  { id: "agent_clear_articulation", label: "Clear Articulation", minWidth: 150 },
  { id: "agent_proactive", label: "Proactive", minWidth: 120 },
  { id: "agent_professional", label: "Professional", minWidth: 100 },
  { id: "agent_rude_avoidence", label: "Rude Avoidance", minWidth: 120 },
  { id: "agent_speaking_clearly", label: "Speaking Clearly", minWidth: 150 },
  { id: "agent_abusive_avoidence", label: "Abusive Avoidance", minWidth: 150 },
  { id: "agent_call_disconnect_avoidence", label: "Call Disconnect Avoidance", minWidth: 180 },
  { id: "agent_hold_return_timing", label: "Hold Return Timing", minWidth: 150 },
  { id: "agent_hold_thanking", label: "Hold Thanking", minWidth: 120 },
  { id: "agent_dead_air_avoidance", label: "Dead Air Avoidance", minWidth: 150 },
  { id: "agent_hold_update_refresh", label: "Hold Update Refresh", minWidth: 150 },
  { id: "agent_retention_effort", label: "Retention Effort", minWidth: 120 },
  { id: "repeat_caller", label: "Repeat Caller", minWidth: 100 },
  { id: "agent_upsell", label: "Upsell", minWidth: 100 },
  { id: "issue_resolved", label: "Issue Resolved", minWidth: 120 },
  { id: "agent_further_assistance", label: "Further Assistance", minWidth: 150 },
  { id: "agent_thanked_customer", label: "Thanked Customer", minWidth: 120 },
  { id: "agent_mentioned_brand_at_closing", label: "Brand Mention Closing", minWidth: 180 },
  { id: "summary", label: "Summary", minWidth: 250 },
  { id: "training_needs_identification", label: "Training needs Identification", minWidth: 250 },
  { id: "areas_of_improvement", label: "Areas of Improvement", minWidth: 250 },

];

let metaArr: any[] = [];

const getData = () => {
  metaArr = [];
  Object.values(HitsArr).forEach((data) => {
    const obj = JSON.parse(JSON.stringify(data));
    metaArr.push(obj);
  });
  return metaArr;
};


type Props = {
  fetchCalls: any;
};

let HitsArr = {};
let downloadArr: any[] = [];

axios.defaults.headers.common["user"] = localStorage.getItem("user");

export default function OpensearchCallsTable({ fetchCalls }: Props) {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [eleRefPoint, setElRefPoint] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>();
  const [downloadData, setDownloadData] = useState<any>();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [agentCountFinal, setAgentCountFinal] = useState<any>([]);
  const [avgDurationFinal, setAvgDurationFinal] = useState<any>([]);                                                                                                                                                                                                                                                                                                                                                                 
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  // const [currentlyPlaying, setCurrentlyPlaying] = useState<string | null>(null);
  // const [anchorAudio, setAnchorAudio] = React.useState<null | HTMLElement>(
  //   null
  // );
  const tableRef = useRef(null);
  // const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
  const bisleriCallsTabDownloadUrl =
    process.env.REACT_APP_BASE_URL + "/bisleri/getCallsDataDownload";

  const convertToTitleCase = (str: string) => {
    return str.replace(/_/g, " ").replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  };
  const convertKeysToTitleCase = (obj: DataItem) => {
    const newObj: DataItem = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[convertToTitleCase(key)] = obj[key];
      }
    }
    return newObj;
  };
  const exportToExcel = (data: any) => {
    // Check if data is defined and is an array
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.error("Invalid or empty data array");
      return;
    }
    // Convert keys to camel case for each object in the array
    const camelCaseData = data.map((obj) => convertKeysToTitleCase(obj));
    // Check if camelCaseData is defined and is an array
    if (
      !camelCaseData ||
      !Array.isArray(camelCaseData) ||
      camelCaseData.length === 0
    ) {
      console.error("Invalid or empty camelCaseData array");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(camelCaseData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // Save the workbook as an XLSX file
    XLSX.writeFile(
      workbook,
      String(localStorage.getItem("user")) + "_Calls.xlsx"
    );
  };
  interface LanguageMapping {
    [key: string]: string;
  }

  const getLanguageName = (languageCode: string): string => {
    const languageMapping: LanguageMapping = {
      "en-IN": "English",
      "ta-IN": "Tamil",
      "ml-IN": "Malayalam",
      "mr-IN": "Marathi",
      "hi-IN": "Hindi",
      "te-IN": "Telugu",
      "kn-IN": "Kannada",
      "gu-IN": "Gujarati",
      // Add more language codes and names as needed
    };
    return languageMapping[languageCode] || "Language not found";
  };

  const getLanguageCode = (languageName: string): string => {
    const languageMapping: LanguageMapping = {
      "English": "en-IN",
      "Tamil": "ta-IN",
      "Malayalam": "ml-IN",
      "Marathi": "mr-IN",
      "Hindi": "hi-IN",
      "Telugu": "te-IN",
      "Kannada": "kn-IN",
      "Gujarati": "gu-IN",
      // Add more language codes and names as needed
    };
    return languageMapping[languageName] || "0";
  };
  const [pageNav, setPageNav] = useState<boolean>(false);

 const downloadDataCall = async () => {
    try {
      setLoading(true);
      const response = await fetchCalls[2]();
      const data = response && response.data && response.data.Hits;
      downloadArr = [];
      Object.values(data).forEach((rowData: any) => {
        const orderedRow: any = {};
        // Iterate through columns to ensure the order
        columns.forEach((column) => {
          const { id } = column;
          orderedRow[id] = rowData.hasOwnProperty(id)
            ? JSON.parse(JSON.stringify(rowData[id]))
            : undefined;
          // Additional processing for specific columns if needed
          if (id === "language" && orderedRow[id] !== undefined) {
            orderedRow[id] = JSON.parse(
              JSON.stringify(getLanguageName(orderedRow[id]))
            );
          }
          // Add more conditions for other columns if needed
        });
        downloadArr.push(orderedRow);
      });
      console.log(downloadArr);
      setDownloadData(downloadArr);
      exportToExcel(downloadArr);
    } catch (error) {
      downloadArr = [];
      setLoading(false); // Set isLoading to false when done or if an error occurs
      console.log(error);
      window.alert("Error Calling Api to Download");
    } finally {
      downloadArr = [];
      setLoading(false); // Set isLoading to false when done or if an error occurs
    }
  };

  const handleDownload = (e: any) => {
    downloadDataCall();
  };

  const handleOnPopoverClose = () => {
    setElRefPoint(null);
    setIsPopoverOpen(false);
  };
  const getPopoverContent = () => {
    if (
      !_.isEmpty(responseData) &&
      !_.isEmpty(agentCountFinal) &&
      !_.isEmpty(avgDurationFinal)
    ) {
      return (
        <AgentDataDetails
          getAgentData={[responseData, agentCountFinal, avgDurationFinal]}
        ></AgentDataDetails>
      );
    } else {
      return <AgentDataDetails></AgentDataDetails>;
    }
  };

      const handleChangePage = (event: unknown, newPage: number) => {
        setTableData([]);
        setPage(newPage);
        setPageNav(true);
        var from = newPage === 0 ? 0 : newPage * rowsPerPage;
        var size = rowsPerPage;
        fetchCalls[1](
          size,
          from
        );
      };
    
      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTableData([]);
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
      
        fetchCalls[1](
       parseInt(event.target.value, 10),
          "0"
        );
      };
    
      if (fetchCalls != undefined && fetchCalls.length != 0) {
        if (fetchCalls[0]["Hits"] != undefined) {
          HitsArr = fetchCalls[0]["Hits"];
        }
      }
    
    
      useEffect(() => {
        if(!pageNav){
          setPage(0);
        }
        setTableData(getData());
        setPageNav(false);
      }, [fetchCalls[0]]);
  

  return (
    <Card>
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="customized table">
            <TableHead sx={{ backgroundColor: "yellow" }}>
              <TableRow>
              {localStorage.getItem("user") === "bisleri" ? (
                  <>
                    {columns.map((column, accessor) => {
                      return (
                        <StyledTableCell
                          key={accessor}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                            backgroundColor: "#1976d2",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          // onClick={() => handleSortingChange(column.id)}
                        >
                          {column.label}
                          {order === "asc" ? (
                            <img
                              alt="upArrow"
                              style={{ height: "12px", paddingLeft: "5px" }}
                              src={images.sortAsc}
                            />
                          ) : order == "" ? null : (
                            <img
                              alt="downArrow"
                              style={{ height: "12px" }}
                              src={images.sortDsc}
                            />
                          )}
                        </StyledTableCell>
                      );
                    })}
                  </>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody>
            {localStorage.getItem("user") === "bisleri" ? (
                <>
                  {tableData &&
                    tableData.map((row: any, rowIdx: any) => {
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={`${row.SNO}_${rowIdx}`} // Combine SNO and rowIdx for a unique key
                        >
                          {columns.map((column, keyId) => {
                            if (column.id === "audio_url") {
                              return (
                                <StyledTableCell
                                  className="sub-color"
                                  key={column.id + rowIdx + keyId}
                                  align={column.align}
                                >
                                  {audioFile(row.audio_url)}
                                </StyledTableCell>
                              );
                            }
                            if (column.id === "language") {
                              return (
                                <StyledTableCell
                                  key={column.id + rowIdx + keyId}
                                  align={column.align}
                                >
                                  {getLanguageName(row[column.id])}
                                </StyledTableCell>
                              );
                            } else {
                              return (
                                <StyledTableCell
                                  key={column.id + rowIdx + keyId}
                                  align={column.align}
                                >
                                  {row[column.id]}
                                </StyledTableCell>
                              );
                            }
                          })}
                        </StyledTableRow>
                      );
                    })}
                </>
              ): null}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 250]}
          component="div"
          count={
            fetchCalls[0]["dataCount"] > 0 ? fetchCalls[0]["dataCount"] : 0
          } // This is what your request should be returning in addition to the current page of rows.
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Popover
        open={isPopoverOpen}
        onClose={handleOnPopoverClose}
        anchorReference="anchorPosition"
        anchorPosition={eleRefPoint}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <span
          className="cs-modal-close"
          onClick={(e) => {
            handleOnPopoverClose();
          }}
        >
          X
        </span>
        {getPopoverContent()}
      </Popover>
      {loading ? (
        <div className="loader_digital" id="loader_digital"></div>
      ) : (
        <Button
          style={{ float: "right", marginTop: "-10px", marginRight: "22px" }}
          onClick={handleDownload}
        >
          Download
        </Button>
      )}
    </Card>
  );
}

function audioFile(url: string) {
  const aud = <audio controls controlsList="nodownload" src={url}></audio>;
  return aud;
}
